/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FoodTransactionHistoryResponsePagination } from './FoodTransactionHistoryResponsePagination';
import {
    FoodTransactionHistoryResponsePaginationFromJSON,
    FoodTransactionHistoryResponsePaginationFromJSONTyped,
    FoodTransactionHistoryResponsePaginationToJSON,
    FoodTransactionHistoryResponsePaginationToJSONTyped,
} from './FoodTransactionHistoryResponsePagination';
import type { FoodTransactionHistoryItem } from './FoodTransactionHistoryItem';
import {
    FoodTransactionHistoryItemFromJSON,
    FoodTransactionHistoryItemFromJSONTyped,
    FoodTransactionHistoryItemToJSON,
    FoodTransactionHistoryItemToJSONTyped,
} from './FoodTransactionHistoryItem';

/**
 * 
 * @export
 * @interface FoodTransactionHistoryResponse
 */
export interface FoodTransactionHistoryResponse {
    /**
     * 
     * @type {Array<FoodTransactionHistoryItem>}
     * @memberof FoodTransactionHistoryResponse
     */
    transactions?: Array<FoodTransactionHistoryItem>;
    /**
     * 
     * @type {FoodTransactionHistoryResponsePagination}
     * @memberof FoodTransactionHistoryResponse
     */
    pagination?: FoodTransactionHistoryResponsePagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof FoodTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof FoodTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof FoodTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the FoodTransactionHistoryResponse interface.
 */
export function instanceOfFoodTransactionHistoryResponse(value: object): value is FoodTransactionHistoryResponse {
    return true;
}

export function FoodTransactionHistoryResponseFromJSON(json: any): FoodTransactionHistoryResponse {
    return FoodTransactionHistoryResponseFromJSONTyped(json, false);
}

export function FoodTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FoodTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(FoodTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : FoodTransactionHistoryResponsePaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function FoodTransactionHistoryResponseToJSON(json: any): FoodTransactionHistoryResponse {
    return FoodTransactionHistoryResponseToJSONTyped(json, false);
}

export function FoodTransactionHistoryResponseToJSONTyped(value?: FoodTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(FoodTransactionHistoryItemToJSON)),
        'pagination': FoodTransactionHistoryResponsePaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

